import { ApiRequestParams, ApiRequestDefaults } from './apiRequestParams';

type Method = 'POST' | 'PATCH' | 'PUT' | 'GET' | 'DELETE';

export class EndpointDefinition<
  RESPONSE extends object | void,
  BODY extends object,
  PARAMS extends ApiRequestParams
> {
  name: string;
  route: string;
  method: Method;
  defaults?: ApiRequestDefaults;

  constructor(config: {
    name: string;
    route: string;
    method: Method;
    defaults?: ApiRequestDefaults;
  }) {
    this.name = config.name;
    this.route = config.route;
    this.method = config.method;
    this.defaults = config.defaults;
  }

  static get<RESPONSE extends object, PARAMS extends ApiRequestParams>({
    name,
    route,
    defaults,
  }: {
    name: string;
    route: string;
    defaults?: ApiRequestDefaults;
  }) {
    return new EndpointDefinition<RESPONSE, null, PARAMS>({
      name,
      route,
      method: 'GET',
      defaults,
    });
  }

  static post<
    RESPONSE extends object | void,
    BODY extends object,
    PARAMS extends ApiRequestParams
  >({
    name,
    route,
    defaults,
  }: {
    name: string;
    route: string;
    defaults?: ApiRequestDefaults;
  }) {
    return new EndpointDefinition<RESPONSE, BODY, PARAMS>({
      name,
      route,
      method: 'POST',
      defaults,
    });
  }

  static delete<RESPONSE extends object, PARAMS extends ApiRequestParams>({
    name,
    route,
    defaults,
  }: {
    name: string;
    route: string;
    defaults?: ApiRequestDefaults;
  }) {
    return new EndpointDefinition<RESPONSE, null, PARAMS>({
      name,
      route,
      method: 'DELETE',
      defaults,
    });
  }

  static patch<
    RESPONSE extends object,
    BODY extends object,
    PARAMS extends ApiRequestParams
  >({
    name,
    route,
    defaults,
  }: {
    name: string;
    route: string;
    defaults?: ApiRequestDefaults;
  }) {
    return new EndpointDefinition<RESPONSE, BODY, PARAMS>({
      name,
      route,
      method: 'PATCH',
      defaults,
    });
  }
}
